import { Raiting } from '@/components';
import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';
import { Pregunta, SurveyStepsHandler } from '@/hooks/useSurvey';

interface RaitingStepProps {
    step: Pregunta;
    handleSurveySteps: SurveyStepsHandler;
    iStep: number;
    finalStep: boolean;
    handleNext: () => void;
}

const RaitingStep = ({ step, handleSurveySteps, iStep, handleNext, finalStep }: RaitingStepProps) => {
    const isTouchDevice = getIsTouchDevice();
    const xs = useMediaQuery('(min-width: 500px)');

    return (
        <>
            <div
                className={`
                    ${isTouchDevice && xs ? 'flex justify-center' : ''}
                    ${isTouchDevice ? 'pb-10' : 'pb-2.5'}
                `}
            >
                <strong
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-right'}
                    `}
                >
                    {step.cPregunta}
                </strong>
            </div>
            <Raiting
                type={step.nTipo}
                raitingValue={Number(step.cValor)}
                setRaitingValue={(value) => {
                    handleSurveySteps(iStep, 'cValor', String(value));
                    if (!finalStep) {
                        handleNext();
                    }
                }}
            />
        </>
    );
};

export default RaitingStep;
